import { render } from "./DailyIncome.vue?vue&type=template&id=d4fb0b9c&scoped=true"
import script from "./DailyIncome.vue?vue&type=script&lang=js"
export * from "./DailyIncome.vue?vue&type=script&lang=js"

import "./DailyIncome.vue?vue&type=style&index=0&id=d4fb0b9c&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4fb0b9c"]])

export default __exports__